import React, { useLayoutEffect, useState, Fragment } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import {connect} from 'react-redux';
import toastMessageActions from 'jd-library/toastMessageActions';
import { updateBrandManufactureDetails } from '../../../../../actions/productSpecification';
import {handleOnChange} from '../../customActions';
import styles from "../manufacturerDetails/styles.scss";

const ImporterDetails = (props) => {
    const {
        editablePuvSpecAttributes,
        initPuvSpecAttributes,
        bMdetails,
        sendDetails,
        specification,
        showToastMessage,
        isMobile
    } = props;

    /**
     *  Manufacturer Related Functions and Options
     *  onSubmitHandler, manufactureForm, handleManufacturerChange, sliderOptions, rightClickHandler
    */
   const [slider, toggleSlider] = useState(false);
   const [inputValue, setInputValue] = useState(null);
   const [mNameError, setmNameError] = useState('');
   const [mAddError, setmAddError] = useState('');

   const [mDetails, setMDetails] = useState({
       'importer': "",
       'importers_detail': ""
   });

   const inputNames = [
       'importer',
       'importers_detail'
   ];

    const manufactureForm = [
        {
            label: 'Importer Name',
            holderClass: styles['manufacturer-input-text'],
            className: props.compliance?.importer && mDetails['importer'] ? 'disabled-input-bg ' : '',
            errorMessage: mNameError,
            input: {
                value: mDetails[inputNames[0]],
                name: inputNames[0],
                type: 'text',
                onChange: (e) => { handleManufacturerChange(e) },
                onFocus: (e) => { handleResetError(e) },
                autoComplete: "off",
                maxLength:100
            }
        },
        {
            label: "Importer's Address/Contact Number",
            holderClass: styles['manufacturer-input-textarea'],
            errorMessage: mAddError,
            as: 'textarea',
            input:{
                value: mDetails[inputNames[1]],
                name: inputNames[1],
                onChange: (e) => handleManufacturerChange(e),
                onFocus: (e) => handleResetError(e),
                autoComplete: "off",
                maxLength: 500,
                className: props.nonEditable ? 'disabled-input-bg' : '',
                style: { wordBreak: 'break-word' }
            }
        }
    ];

    const handleResetError = (e) =>{
        const {
            value,
            name,
        } = e.target;
        if(name == 'importer') {
            setmNameError('');
        }
        if(name == 'importers_detail') {
            setmAddError('');
        }
    }

    const sliderOptions = {
        avoidPortal:"true",
        header: {
            heading: "Importer Details",
            variant: "secondary",
            rightIcons: isMobile?  [] : [{
                className: 'icon-HDRcross',
                onClick: () => {
                    historyHandler.closeCurrent();
                }
            }],
            leftIcons: [{
                className: 'icon-HDRback',
                onClick: () => {
                    if(bMdetails.importer != mDetails['importer'] || bMdetails.importers_detail != mDetails['importers_detail']){
                        setmNameError('');
                        setmAddError('');
                        setMDetails({
                            importer: bMdetails.importer || '',
                            importers_detail: bMdetails.importers_detail || ''
                        });
                    }
                    historyHandler.closeCurrent();
                }
            }]
        },
        onHidden : () => {
            toggleSlider(false);
            // props.resetSpecificationFormData();
        },
        footer: {
            btnProps: [{
                children: props.nonEditable ? 'Back' : 'Save',
                onClick: () => { props.nonEditable ? historyHandler.closeCurrent() : onSubmitHandler() }
            }]
        }
    }

    const handleManufacturerChange = (e) => {
        const {
            value,
            name,
        } = e.target;

        if(name == 'importer' && value) {
            setmNameError('');
        }
        if(name == 'importers_detail' && value) {
            setmAddError('');
        }
        // let parentIndex = name == 'importer'?props.nameIndex:props.detailIndex;
        // let item = props.editablePuvSpecAttributes[parentIndex];
        // parentIndex && props.handleOnChange({e, parentIndex, item, key: "value"})
        setMDetails(prev => ({
            ...prev,
            [name]: value
        }));
    }

    // Removing manufacturing name on main input

    const onSubmitHandler = () => {
        let isUserInteracted = mDetails[inputNames[0]] || mDetails[inputNames[1]] 
        let error = '';
        if(isUserInteracted) {
            if(!mDetails[inputNames[1]]) {
                error = 'Please Enter Importer’s Address/Contact Number';
                setmAddError('Please Enter Importer’s Address/Contact Number');
            }else if(mDetails[inputNames[1]].length < 10) {
                error = 'Please Enter Valid Importer’s Address/Contact Number';
                setmAddError('Please Enter Valid Importer’s Address/Contact Number');
            }
    
            if(!mDetails[inputNames[0]]) {
                error = 'Please Enter Importer Name';
                setmNameError('Please Enter Importer Name');
            }else if(mDetails[inputNames[0]].length < 3) {
                error = 'Please Enter Valid Importer Name';
                setmNameError('Please Enter Valid Importer Name');
            }
        }

        if(error) {
            showToastMessage({ showToastMessage: true, message: error, type: (isMobile ? 'info' : 'error') });
        } else {
            let bmData = [...sendDetails];
            bmData.map((cur,index) => {
                if(['importer','importers_detail'].includes(cur.name)) {
                    cur.values = [mDetails[cur.name]]
                    let parentIndex = cur.name == 'importer'?props.nameIndex:props.detailIndex;
                    let item = props.editablePuvSpecAttributes[parentIndex];
                    parentIndex && props.handleOnChange({e: {target:{value: cur.values[0]}}, parentIndex, item, key: "value"})
                }
            })
            props.updateBrandManufactureDetails({
                [inputNames[0]]: mDetails[inputNames[0]],
                [inputNames[1]]: mDetails[inputNames[1]],
                sendDetails: [...bmData]
            });
            setInputValue(mDetails[inputNames[0]]);
            historyHandler.closeCurrent();
        }

    }


    /**
     *  Brand Related Functions and Options
     *  removeBrandHandler, brandSubmitHandler
    */
   const [brandDetails, setBrandDetails] = useState({});
   const [brand, setBrand] = useState(null);
   const [isBrandPresent, setIsBrandPresent] = useState(false);
   const [isFocused,changeFocus] = useState(false);
   const {
       s_type_options=[]
   } = brandDetails;

   const updateErrorsField = (key,value) => {
       let error = {...props.errors};
       error[key] = value;
       props.updateError(error);
   }

    useLayoutEffect(() => {

        if(bMdetails.importer || bMdetails.importers_detail) {
            setMDetails({
                importer: bMdetails.importer || '',
                importers_detail: bMdetails.importers_detail || ''
            });
            setInputValue(bMdetails.importer);
        }

    }, [editablePuvSpecAttributes,bMdetails.importer,bMdetails.importers_detail]);

    return (<Fragment>
                <InputWithMovingLabel
                    label="Importer Details"
                    input={{
                        value: inputValue,
                        onClick: () => {
                            toggleSlider(props.nonEditable ? false : !slider);
                            if(props.errors['ImporterDetails']){
                                updateErrorsField('ImporterDetails','');
                            }
                        },
                        readOnly: true,
                        autoFocus: false
                    }}
                    className={''}
                    onRightIconClick={() => toggleSlider(!slider)}
                    rightIconClass={"icon-Next"}
                    holderClass={`${styles['manufacturer-input-text']} ${styles['hand-pointer']} ${
                        props.isReadOnly ? "read-only-mode" : ""
                    }`}
                    errorMessage={props.errors['ImporterDetails']}
                />
                {slider ? <SliderWrapper {...sliderOptions}>
                    <div className={styles['manufacturer-details-section']}>
                        {manufactureForm.map((element) => <InputWithMovingLabel {...element} />)}
                    </div>
                </SliderWrapper> : null}
            </Fragment>);
}

const mapStateToProps = (state, props) => {
    let editablePuvSpecAttributes = state.productSpecification.editablePuvSpecAttributes;
    let nameIndex = '';
    let detailIndex = '';
    editablePuvSpecAttributes.map((cur,index) => {
        if(cur.s_nm == 'importer'){
            nameIndex = index;
        }
        if(cur.s_nm == 'importers_detail'){
            detailIndex = index;
        }
    })
    return {
        ...props,
        editablePuvSpecAttributes,
        nameIndex,
        detailIndex,
        specification: state.products.editProduct.specification,
        compliance: state.products.editProduct.compliance,
        bMdetails: state.brandManufacturer,
        sendDetails: state.brandManufacturer.sendDetails,
        isSellOnline: state.products.editProduct.isSellOnline,
        isReadOnly: state.session.isReadOnly
    }
};

const mapDispatchToProps = (dispatch) => ({
    updateBrandManufactureDetails: (payload) => dispatch(updateBrandManufactureDetails(payload)),
    showToastMessage: (payload) => dispatch(toastMessageActions.showMessage(payload)),
    handleOnChange: (options) =>  handleOnChange(options, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ImporterDetails);
